import {
  Component, Vue,
} from 'vue-property-decorator';
import WithRender from './lawyer-persona.html';
import BasePersona from '../base-persona/BasePersona';
import SharedDataService from '@/modules/shared/services/sharedDataService';
import { Inject } from 'vue-di-container';

@WithRender
@Component({
  components: {
    BasePersona,
  },
})
export default class LawyerPersona extends Vue {
  @Inject()
  public sharedDataService!:SharedDataService;

  public get target() {
    return [this.sharedDataService.Personas.LAWYER];
  }
}
